import { Select } from "antd";
import React, { useEffect, useRef, useState } from 'react';
import { filterOption, renderOpts } from "../../../../../../util/varibles/global";
import { callEventEditOp, useEditOp } from "../../EditOperationContext";

interface IProps {
    className?: string
    value?: { id: string, name: string }[] | string
    mode?: "multiple"

    onChange?(value: ({ id: string, name: string }[]) | { label: string, value: string }): void
}

const Location: React.FC<IProps> = ({ className = 'h-36 select-mode-tag', value, mode, onChange }) => {
    const [selected, setSelected] = useState<(string[] | string)>([]);
    const [pois] = useEditOp(state => state.pois);
    const { getLocations } = callEventEditOp();
    const getLocationsRef = useRef(getLocations);

    useEffect(() => {
        getLocationsRef.current = getLocations;
    }, [getLocations]);

    useEffect(() => {
        getLocationsRef.current()
    }, []);

    useEffect(() => {
        let current
        if (value === undefined) {
            current = mode === "multiple" ? [] : ''
        } else
            current = value
        setSelected(Array.isArray(current) ? current.map(item => item.id) : current)
    }, [value, mode]);

    const handleChange = (data: { label: string, value: string }, add: boolean) => {
        if (onChange) {
            if (mode === 'multiple') {
                const old = value || []
                if (!Array.isArray(old))
                    return;

                if (add)
                    onChange([...old, { id: data.value, name: data.label }])
                else
                    onChange(old.filter(item => item.id !== data.value))
            } else
                onChange(data)
        }
    }

    return <Select
        mode={mode}
        className={className}
        loading={pois.loading}
        showSearch={{ filterOption }}
        placeholder='Location'
        options={renderOpts(pois.data)}
        value={pois.loading ? null : selected}
        onSelect={(...args) => handleChange(args[1], true)}
        onDeselect={(...args) => handleChange(args[1], false)}
    />;
};

export default Location;
